unit LanguageTermList;
{

/* Initial. */

}
interface

uses
  DateUtils, StrUtils, SysUtils, WEBLib.Dialogs,
  LanguageTerm, TermListGetResponse, TermType;

type
  TLanguageTermArray = array of TLanguageTerm;

  TLanguageTermList = class
  private
    p_Array_LanguageTerm: TLanguageTermArray;
    p_String_GoodMorning: String;
    p_String_GoodAfterNoon: String;
    p_String_GoodEvening: String;
    p_String_GoodNight: String;
  public
    property GoodMorning: String read p_String_GoodMorning;
    property GoodAfterNoon: String read p_String_GoodAfterNoon;
    property GoodEvening: String read p_String_GoodEvening;
    property GoodNight: String read p_String_GoodNight;
    procedure FillProperties;
    procedure AddLanguageTerm(const String_Code: String; const String_EnglishTerm: String; const String_LanguageTerm: String; const String_MemberOf: String);
    function LoadLanguageTerms(const TermListGetResponse: TTermListGetResponse): Boolean;
    function GetLanguageTerm(const String_EnglishTerm: String): String;
    function GetLanguageTermOnCode(const String_Code: String): String;
    function GetLanguageTermsOnMemberOf(const String_MemberOf: String): array of String;
    function GetCodeOnLanguageTerm(const String_LanguageTerm: String): String;
    function GetDateOnLanguage(const String_Date: String): String;
  end;

var
  LanguageTermList_Language: TLanguageTermList;

implementation

uses
  Config;

procedure TLanguageTermList.FillProperties;
begin
  p_String_GoodMorning := GetLanguageTerm('Good morning');
  p_String_GoodAfternoon := GetLanguageTerm('Good afternoon');
  p_String_GoodEvening := GetLanguageTerm('Good evening');
  p_String_GoodNight := GetLanguageTerm('Good night');
end;

procedure TLanguageTermList.AddLanguageTerm(const String_Code: String; const String_EnglishTerm: String; const String_LanguageTerm: String; const String_MemberOf: String);
var
  LanguageTerm: TLanguageTerm;

begin
  LanguageTerm := TLanguageTerm.Create(String_Code, String_EnglishTerm, String_LanguageTerm, String_MemberOf);

  Insert(LanguageTerm, p_Array_LanguageTerm, High(p_Array_LanguageTerm));
end;

// Load language terms from server.
function TLanguageTermList.LoadLanguageTerms(const TermListGetResponse: TTermListGetResponse): Boolean;
var
  TermType: TTermType;
  Boolean_Result: Boolean;
begin
  Boolean_Result := False;

  SetLength(p_Array_LanguageTerm, 0);

  if (Length(TermListGetResponse.TermList.TermArray) > 0) then
  begin
    Boolean_Result := True;

    for TermType in TermListGetResponse.TermList.TermArray do
    begin
      AddLanguageTerm(TermType.Code, TermType.EnglishTerm, TermType.LanguageTerm, TermType.MemberOf);
    end;
  end;

  FillProperties;

  Result := Boolean_Result;
end;

function TLanguageTermList.GetLanguageTerm(const String_EnglishTerm: String): String;
var
  LanguageTerm: TLanguageTerm;
  String_LanguageTerm: String;
begin
  String_LanguageTerm := String_EnglishTerm;

  if Length(p_Array_LanguageTerm) > 0 then
  begin
    for LanguageTerm in p_Array_LanguageTerm do
    begin
      if LanguageTerm.EnglishTerm = String_EnglishTerm then
      begin
        String_LanguageTerm := LanguageTerm.LanguageTerm;

        Break;
      end;
    end;
  end;

  Result := String_LanguageTerm;
end;

function TLanguageTermList.GetLanguageTermOnCode(const String_Code: String): String;
var
  LanguageTerm: TLanguageTerm;
  String_LanguageTerm: String;
begin
  String_LanguageTerm := String_Code;

  if Length(p_Array_LanguageTerm) > 0 then
  begin
    for LanguageTerm in p_Array_LanguageTerm do
    begin
      if LanguageTerm.Code = String_Code then
      begin
        String_LanguageTerm := LanguageTerm.LanguageTerm;

        Break;
      end;
    end;
  end;

  Result := String_LanguageTerm;
end;

function TLanguageTermList.GetLanguageTermsOnMemberOf(const String_MemberOf: String): array of String;
var
  LanguageTerm: TLanguageTerm;
  Array_LanguageTerms: array of String;
begin
  SetLength(Array_LanguageTerms, 0);

  if Length(p_Array_LanguageTerm) > 0 then
  begin
    for LanguageTerm in p_Array_LanguageTerm do
    begin
      if LanguageTerm.MemberOf = String_MemberOf then Insert(LanguageTerm.LanguageTerm, Array_LanguageTerms, High(Array_LanguageTerms));
    end;
  end;

  Result := Array_LanguageTerms;
end;

function TLanguageTermList.GetCodeOnLanguageTerm(const String_LanguageTerm: String): String;
var
  LanguageTerm: TLanguageTerm;
  String_Code: String;
begin
  String_Code := '';

  if Length(p_Array_LanguageTerm) > 0 then
  begin
    for LanguageTerm in p_Array_LanguageTerm do
    begin
      if LanguageTerm.LanguageTerm = String_LanguageTerm then
      begin
        String_Code := LanguageTerm.Code;

        Break
      end;
    end;
  end;

  Result := String_Code;
end;

function TLanguageTermList.GetDateOnLanguage(const String_Date: String): String;
var
  Strings_Date: array of String;
  Date_Value: TDateTime;
  String_DateFormat: String;
  String_DateResult: String;
begin
  // Create date from string.
  if Length(String_Date) > 0 then
  begin
    Strings_Date := SplitString(String_Date, '-');

    Date_Value := EncodeDateTime(StrToInt(Strings_Date[0]), StrToInt(Strings_Date[1]), StrToInt(Strings_Date[2]), 0, 0 ,0, 0);

    // Format in the language format.
    String_DateFormat := GetLanguageTerm('mm/dd/yyyy');
    String_DateResult := FormatDateTime(String_DateFormat, Date_Value);
  end
  else
     String_DateResult := '';

  Result := String_DateResult;
end;

end.
